<template>
  <div class="has-tab-bar">
    <AppBar title="" :show-back-button="true"></AppBar>
    <SpinnerLoader v-if="loading || paymentStatusLoading"></SpinnerLoader>
    <div v-if="!loading && !paymentStatusLoading" class="container">
      <template v-if="action === 'payment'">
        <template v-if="paymentSuccess">
          <h1>Gelukt!</h1>
          <p>Je kunt nu gebruik maken van je strippenkaart</p>
        </template>
        <template v-else-if="paymentPending">
          <h1>In behandeling</h1>
          <p>
            Je betaling wordt nog verwerkt. Dit kan enkele minuten duren. Je
            ontvangt een bevestiging per e-mail zodra de betaling is afgerond en
            je strippenkaart beschikbaar is.
          </p>
        </template>
        <template v-else-if="paymentFailed">
          <h1>Oeps...</h1>
          <p>
            Je betaling is helaas niet gelukt. Probeer het opnieuw of neem
            contact met ons op via contact@inviplay.nl.
          </p>
        </template>
        <template v-else>
          <h1>Oeps...</h1>
          <p>
            We konden de status van je betaling niet ophalen. Controleer je
            e-mail voor een bevestiging of neem contact met ons op via
            contact@inviplay.nl.
          </p>
        </template>
      </template>
      <template v-else>
        <h1>Gelukt!</h1>
        <p>Je kunt nu gebruik maken van je strippenkaart</p>
      </template>
    </div>
    <TabBar selected="" />
  </div>
</template>

<script>
import AppBar from '@/components/AppBar'
import SpinnerLoader from '@/components/SpinnerLoader'
import TabBar from '@/components/TabBar'
import { mapState } from 'vuex'
import { PAYMENT_GET_STATUS_BY_ID } from '@/store/actions/payment'

export default {
  name: 'CreditcardConfirmation',
  components: { AppBar, SpinnerLoader, TabBar },
  data() {
    return {
      paymentId: this.$route.query.pid,
      paymentStatusLoading: false,
      numberOfRepeats: 0,
      paymentStatusTimeout: null,
      paymentOverallTimeout: null
    }
  },
  computed: {
    ...mapState({
      loading: (state) => state.payment.loading,
      paymentStatus: (state) => state.payment.status
    }),
    action: function () {
      return this.$route.query.action
    },
    paymentSuccess() {
      return this.paymentId && this.paymentStatus
        ? this.paymentStatus[this.paymentId] === 'paid' ||
            this.paymentStatus[this.paymentId] === 'completed'
        : false
    },
    paymentPending() {
      if (!this.paymentId || !this.paymentStatus) return false
      const status = this.paymentStatus[this.paymentId]
      return status === 'pending' || status === 'open' || status === 'created'
    },
    paymentFailed() {
      if (!this.paymentId || !this.paymentStatus) return false
      const status = this.paymentStatus[this.paymentId]
      return (
        status === 'expired' ||
        status === 'failed' ||
        status === 'canceled' ||
        status === 'cancelled'
      )
    }
  },
  watch: {
    paymentStatus: {
      immediate: true,
      handler(paymentStatus) {
        if (this.action !== 'payment' || !this.paymentId) return
        const status = paymentStatus && paymentStatus[this.paymentId]
        if (!status) return
        if (status === 'open' || status === 'pending' || status === 'created') {
          this.retryPaymentStatus()
        } else {
          this.stopPaymentPolling()
          this.paymentStatusLoading = false
        }
      }
    }
  },
  created: function () {
    if (this.action === 'payment' && this.paymentId) {
      const existingStatus =
        this.paymentStatus && this.paymentStatus[this.paymentId]
      if (!existingStatus) {
        this.paymentStatusLoading = true
        this.paymentOverallTimeout = setTimeout(() => {
          this.stopPaymentPolling()
          this.paymentStatusLoading = false
        }, 15000)
      }
      this.$store.dispatch(PAYMENT_GET_STATUS_BY_ID, {
        paymentId: this.paymentId
      })
    }
  },
  beforeDestroy: function () {
    this.stopPaymentPolling()
  },
  methods: {
    stopPaymentPolling: function () {
      if (this.paymentStatusTimeout) {
        clearTimeout(this.paymentStatusTimeout)
        this.paymentStatusTimeout = null
      }
      if (this.paymentOverallTimeout) {
        clearTimeout(this.paymentOverallTimeout)
        this.paymentOverallTimeout = null
      }
    },
    retryPaymentStatus: function () {
      if (this.numberOfRepeats < 10) {
        this.paymentStatusTimeout = setTimeout(() => {
          this.$store.dispatch(PAYMENT_GET_STATUS_BY_ID, {
            paymentId: this.paymentId
          })
          this.numberOfRepeats++
        }, 2000)
      } else {
        this.stopPaymentPolling()
        this.paymentStatusLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
</style>
